import { IInfoBoxLayout } from '../../types/layout/info-box';
import Button from '../button';

function InfoBox({ button, className, html }: IInfoBoxLayout) {
    return (
        <div className={['small-box', className || 'bg-success'].join(' ')}>
            <div className="inner" dangerouslySetInnerHTML={{ __html: html }} />
            {button instanceof Object && (
                <Button {...button} className="small-box-footer" />
            )}
        </div>
    );
}

export default InfoBox;
